
import './App.css';
import About from './components/About';
import WebsiteDesign from './components/WebsiteDesign';
import {
  Route,
  Switch
} from "react-router-dom";
import Work from './pages/Work';
import Contact from './pages/Contact';
import WebsiteDesignDevelopment from './pages/WebsiteDesignDevelopment';
import WebsiteMaintenance from './pages/WebsiteMaintenance';
import SocialMediaMarketing from './pages/SocialMediaMarketing';
import SeoService from './pages/SeoService';
import GraphicDesigning from './pages/GraphicDesigning';
import Services from './pages/Services';
import Review from './pages/Review';



import {Airoli,Ambernath,Ambivli,Andheri,Asangaon,Atgaon,Badlapur,Bandra,Bhandup,Bhayandar,Bhivpuri,
    Bhiwandi,Boisar,Borivali,Byculla,CbdBelapur,CharniRoad,Chembur,Chinchpokli,Chunabhatti,
    Churchgate,Colaba,Cst,CurreyRoad,Dadar,Dharavi,Diva,Dombivli,Fort,Ghansoli,Ghatkopar,Goregaon,
    Govandi,GrantRoad,GtbNagar,Jogeshwari,Kalamboli,Kalbadevi,Kalwa,Kalyan,
    Kamothe,Kandivali,Kanjurmarg,Karjat,Kasara,Khadavli,Khar, Khardi, Kharghar, Kopar, KoparKhairane, Kurla, LowerParel, Mahalakshmi, Mahape, Mahim, Majiwada, Malad, Mankhurd, MasjidBander, Matunga, Mazgaon, MiraRoad, Mumbai, MumbaiCentral, Mumbra, Nahur, Naigaon, NallaSopara, Naupada, NaviMumbai, Neral, Nerul, Palava, Palghar, Panvel, Parel, Powai, Prabhadevi, Rabale, Sakinaka, SandhurstRoad, Sanpada, Santacruz, Shahad, Shelu, Sion, Taloja, Thakurli, Thane, Tilaknagar, Titvala, Turbhe, Ulhasnagar, Ulwe, Umroli, Vangani, Vashi, Vasind, Versova, Vidyavihar, Vikhroli, VilleParle, Virar, Vithalwadi, WagleEstate, Worli} from './pages/seo-tags/City';
import Contact1 from './pages/Contact-form/Contact1';
import Connection from './pages/Connection';

function Routing() {
    return (
        <Switch>
            <Route exact path="/">
                <WebsiteDesign />
            </Route>
            <Route exact path="/about">
                <About />
            </Route>
            <Route exact path="/website-design-development">
                <WebsiteDesignDevelopment />
            </Route>
            <Route exact path="/website-maintenance-service">
                <WebsiteMaintenance />
            </Route>
            <Route exact path="/work">
                <Work />
            </Route>
            <Route exact path="/contact">
                <Contact />
            </Route>
            <Route exact path="/contact1">
                <Contact1 />
            </Route>
            <Route exact path="/services">
                <Services />
            </Route>
            <Route exact path="/Website-Desgn">
                <WebsiteDesign />
            </Route>
            <Route exact path="/social-media-marketing">
                <SocialMediaMarketing />
            </Route>
            <Route exact path="/seo-service">
                <SeoService />
            </Route>
            <Route exact path="/graphic-designing">
                <GraphicDesigning />
            </Route>
            <Route exact path="/testimonial">
                <Review />
            </Route>
            <Route exact path="/connection">
                <Connection />
            </Route>




            {/* Tags */}
            <Route exact path="/website-designers-in-airoli">
                <Airoli />
            </Route>
            <Route exact path="/website-designers-in-ambernath">
                <Ambernath />
            </Route>
            <Route exact path="/website-designers-in-ambivli">
                <Ambivli />
            </Route>
            <Route exact path="/website-designers-in-andheri">
                <Andheri />
            </Route>
            <Route exact path="/website-designers-in-asangaon">
                <Asangaon />
            </Route>
            <Route exact path="/website-designers-in-atgaon">
                <Atgaon />
            </Route>
            <Route exact path="/website-designers-in-badlapur">
                <Badlapur />
            </Route>
            <Route exact path="/website-designers-in-bandra">
                <Bandra />
            </Route>
            <Route exact path="/website-designers-in-bhayandar">
                <Bhayandar />
            </Route>
            <Route exact path="/website-designers-in-bhivpuri">
                <Bhivpuri />
            </Route>
            <Route exact path="/website-designers-in-bhiwandi">
                <Bhiwandi />
            </Route>
            <Route exact path="/website-designers-in-boisar">
                <Boisar />
            </Route>
            <Route exact path="/website-designers-in-borivali">
                <Borivali />
            </Route>
            <Route exact path="/website-designers-in-byculla">
                <Byculla />
            </Route>
            <Route exact path="/website-designers-in-cbd-belapur">
                <CbdBelapur />
            </Route>
            <Route exact path="/website-designers-in-charni-road">
                <CharniRoad />
            </Route>
            <Route exact path="/website-designers-in-chembur">
                <Chembur />
            </Route>
            <Route exact path="/website-designers-in-chinchpokli">
                <Chinchpokli />
            </Route>
            <Route exact path="/website-designers-in-chunabhatti">
                <Chunabhatti />
            </Route>
            <Route exact path="/website-designers-in-churchgate">
                <Churchgate />
            </Route>
            <Route exact path="/website-designers-in-colaba">
                <Colaba />
            </Route>
            <Route exact path="/website-designers-in-cst">
                <Cst />
            </Route>
            <Route exact path="/website-designers-in-currey-road">
                <CurreyRoad />
            </Route>
            <Route exact path="/website-designers-in-dadar">
                <Dadar />
            </Route>
            <Route exact path="/website-designers-in-dharavi">
                <Dharavi />
            </Route>
            <Route exact path="/website-designers-in-diva">
                <Diva />
            </Route>
            <Route exact path="/website-designers-in-dombivli">
                <Dombivli />
            </Route>
            <Route exact path="/website-designers-in-fort">
                <Fort />
            </Route>
            <Route exact path="/website-designers-in-ghansoli">
                <Ghansoli />
            </Route>
            <Route exact path="/website-designers-in-ghatkopar">
                <Ghatkopar />
            </Route>
            <Route exact path="/website-designers-in-goregaon">
                <Goregaon />
            </Route>
            <Route exact path="/website-designers-in-govandi">
                <Govandi />
            </Route>
            <Route exact path="/website-designers-in-grant-road">
                <GrantRoad />
            </Route>
            <Route exact path="/website-designers-in-gtb-nagar">
                <GtbNagar />
            </Route>
            <Route exact path="/website-designers-in-jogeshwari">
                <Jogeshwari />
            </Route>
            <Route exact path="/website-designers-in-kalamboli">
                <Kalamboli />
            </Route>
            <Route exact path="/website-designers-in-kalbadevi">
                <Kalbadevi />
            </Route>
            <Route exact path="/website-designers-in-kalwa">
                <Kalwa />
            </Route>
            <Route exact path="/website-designers-in-kalyan">
                <Kalyan />
            </Route>
            <Route exact path="/website-designers-in-kamothe">
                <Kamothe />
            </Route>
            <Route exact path="/website-designers-in-kandivali">
                <Kandivali />
            </Route>
            <Route exact path="/website-designers-in-kanjurmarg">
                <Kanjurmarg />
            </Route>
            <Route exact path="/website-designers-in-karjat">
                <Karjat />
            </Route>
            <Route exact path="/website-designers-in-kasara">
                <Kasara />
            </Route>
            <Route exact path="/website-designers-in-khadavli">
                <Khadavli />
            </Route>
            <Route exact path="/website-designers-in-khar">
                <Khar />
            </Route>
            <Route exact path="/website-designers-in-khardi">
                <Khardi />
            </Route>
            <Route exact path="/website-designers-in-kharghar">
                <Kharghar />
            </Route>
            <Route exact path="/website-designers-in-kopar-khairane">
                <KoparKhairane />
            </Route>
            <Route exact path="/website-designers-in-kopar">
                <Kopar />
            </Route>
            <Route exact path="/website-designers-in-kurla">
                <Kurla />
            </Route>
            <Route exact path="/website-designers-in-lower-parel">
                <LowerParel />
            </Route>
            <Route exact path="/website-designers-in-mahalakshmi">
                <Mahalakshmi />
            </Route>
            <Route exact path="/website-designers-in-mahape">
                <Mahape />
            </Route>
            <Route exact path="/website-designers-in-mahim">
                <Mahim />
            </Route>
            <Route exact path="/website-designers-in-majiwada">
                <Majiwada />
            </Route>
            <Route exact path="/website-designers-in-malad">
                <Malad />
            </Route>
            <Route exact path="/website-designers-in-mankhurd">
                <Mankhurd />
            </Route>
            <Route exact path="/website-designers-in-masjid-bander">
                <MasjidBander />
            </Route>
            <Route exact path="/website-designers-in-matunga">
                <Matunga />
            </Route>
            <Route exact path="/website-designers-in-mazgaon">
                <Mazgaon />
            </Route>
            <Route exact path="/website-designers-in-mira-road">
                <MiraRoad />
            </Route>
            <Route exact path="/website-designers-in-mumbai-central">
                <MumbaiCentral />
            </Route>
            <Route exact path="/website-designers-in-mumbai">
                <Mumbai />
            </Route>
            <Route exact path="/website-designers-in-mumbra">
                <Mumbra />
            </Route>
            <Route exact path="/website-designers-in-nahur">
                <Nahur />
            </Route>
            <Route exact path="/website-designers-in-naigaon">
                <Naigaon />
            </Route>
            <Route exact path="/website-designers-in-nalla-sopara">
                <NallaSopara />
            </Route>
            <Route exact path="/website-designers-in-naupada">
                <Naupada />
            </Route>
            <Route exact path="/website-designers-in-navi-mumbai">
                <NaviMumbai />
            </Route>
            <Route exact path="/website-designers-in-neral">
                <Neral />
            </Route>
            <Route exact path="/website-designers-in-nerul">
                <Nerul />
            </Route>
            <Route exact path="/website-designers-in-palava">
                <Palava />
            </Route>
            <Route exact path="/website-designers-in-palghar">
                <Palghar />
            </Route>
            <Route exact path="/website-designers-in-panvel">
                <Panvel />
            </Route>
            <Route exact path="/website-designers-in-parel">
                <Parel />
            </Route>
            <Route exact path="/website-designers-in-powai">
                <Powai />
            </Route>
            <Route exact path="/website-designers-in-prabhadevi">
                <Prabhadevi />
            </Route>
            <Route exact path="/website-designers-in-rabale">
                <Rabale />
            </Route>
            <Route exact path="/website-designers-in-sakinaka">
                <Sakinaka />
            </Route>
            <Route exact path="/website-designers-in-sandhurst-road">
                <SandhurstRoad />
            </Route>
            <Route exact path="/website-designers-in-sanpada">
                <Sanpada />
            </Route>
            <Route exact path="/website-designers-in-santacruz">
                <Santacruz />
            </Route>
            <Route exact path="/website-designers-in-shahad">
                <Shahad />
            </Route>
            <Route exact path="/website-designers-in-shelu">
                <Shelu />
            </Route>
            <Route exact path="/website-designers-in-sion">
                <Sion />
            </Route>
            <Route exact path="/website-designers-in-taloja">
                <Taloja />
            </Route>
            <Route exact path="/website-designers-in-thakurli">
                <Thakurli />
            </Route>
            <Route exact path="/website-designers-in-tilaknagar">
                <Tilaknagar />
            </Route>
            <Route exact path="/website-designers-in-titvala">
                <Titvala />
            </Route>
            <Route exact path="/website-designers-in-turbhe">
                <Turbhe />
            </Route>
            <Route exact path="/website-designers-in-ulhasnagar">
                <Ulhasnagar />
            </Route>
            <Route exact path="/website-designers-in-ulwe">
                <Ulwe />
            </Route>
            <Route exact path="/website-designers-in-umroli">
                <Umroli />
            </Route>
            <Route exact path="/website-designers-in-vangani">
                <Vangani />
            </Route>
            <Route exact path="/website-designers-in-vashi">
                <Vashi />
            </Route>
            <Route exact path="/website-designers-in-vasind">
                <Vasind />
            </Route>
            <Route exact path="/website-designers-in-versova">
                <Versova />
            </Route>
            <Route exact path="/website-designers-in-vidyavihar">
                <Vidyavihar />
            </Route>
            <Route exact path="/website-designers-in-vikhroli">
                <Vikhroli />
            </Route>
            <Route exact path="/website-designers-in-ville-parle">
                <VilleParle />
            </Route>
            <Route exact path="/website-designers-in-virar">
                <Virar />
            </Route>
            <Route exact path="/website-designers-in-Vithalwadi">
                <Vithalwadi />
            </Route>
            <Route exact path="/website-designers-in-wagle-estate">
                <WagleEstate />
            </Route>
            <Route exact path="/website-designers-in-worli">
                <Worli />
            </Route>
            <Route exact path="/website-design-company-in-thane">
                <Thane />
            </Route>
            <Route exact path="/website-design-company-in-bhandup">
                <Bhandup />
            </Route>


        </Switch>
    )
}

export default Routing
